import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Calendar = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/calendar-2">
        <g id="calendar-2">
          <path
            id="Vector"
            d="M5.33203 3.83337C5.0587 3.83337 4.83203 3.60671 4.83203 3.33337V1.33337C4.83203 1.06004 5.0587 0.833374 5.33203 0.833374C5.60536 0.833374 5.83203 1.06004 5.83203 1.33337V3.33337C5.83203 3.60671 5.60536 3.83337 5.33203 3.83337Z"
          />
          <path
            id="Vector_2"
            d="M10.668 3.83337C10.3946 3.83337 10.168 3.60671 10.168 3.33337V1.33337C10.168 1.06004 10.3946 0.833374 10.668 0.833374C10.9413 0.833374 11.168 1.06004 11.168 1.33337V3.33337C11.168 3.60671 10.9413 3.83337 10.668 3.83337Z"
          />
          <path
            id="Vector_3"
            d="M13.6654 6.55994H2.33203C2.0587 6.55994 1.83203 6.33327 1.83203 6.05994C1.83203 5.7866 2.0587 5.55994 2.33203 5.55994H13.6654C13.9387 5.55994 14.1654 5.7866 14.1654 6.05994C14.1654 6.33327 13.9387 6.55994 13.6654 6.55994Z"
          />
          <path
            id="Vector_4"
            d="M10.6667 15.1667H5.33333C2.9 15.1667 1.5 13.7667 1.5 11.3334V5.66671C1.5 3.23337 2.9 1.83337 5.33333 1.83337H10.6667C13.1 1.83337 14.5 3.23337 14.5 5.66671V11.3334C14.5 13.7667 13.1 15.1667 10.6667 15.1667ZM5.33333 2.83337C3.42667 2.83337 2.5 3.76004 2.5 5.66671V11.3334C2.5 13.24 3.42667 14.1667 5.33333 14.1667H10.6667C12.5733 14.1667 13.5 13.24 13.5 11.3334V5.66671C13.5 3.76004 12.5733 2.83337 10.6667 2.83337H5.33333Z"
          />
          <path
            id="Vector_5"
            d="M5.66667 9.66672C5.58 9.66672 5.49333 9.64672 5.41333 9.61339C5.33333 9.58006 5.26001 9.53338 5.19334 9.47338C5.13334 9.40671 5.08666 9.33338 5.05332 9.25339C5.01999 9.17339 5 9.08672 5 9.00005C5 8.82672 5.07334 8.65339 5.19334 8.52672C5.26001 8.46672 5.33333 8.42004 5.41333 8.38671C5.53333 8.33337 5.66667 8.32004 5.80001 8.34671C5.84001 8.35337 5.88 8.36671 5.92 8.38671C5.96 8.40004 6 8.42006 6.04 8.44672C6.07333 8.47339 6.10666 8.50005 6.13999 8.52672C6.16666 8.56005 6.19999 8.59338 6.21999 8.62672C6.24666 8.66672 6.26668 8.70671 6.28001 8.74671C6.30001 8.78671 6.31334 8.82671 6.32001 8.86671C6.32667 8.91337 6.33333 8.95338 6.33333 9.00005C6.33333 9.17338 6.25999 9.34671 6.13999 9.47338C6.01333 9.59338 5.84 9.66672 5.66667 9.66672Z"
          />
          <path
            id="Vector_6"
            d="M7.9987 9.6667C7.82536 9.6667 7.65204 9.59337 7.52537 9.47337C7.4987 9.44003 7.47204 9.4067 7.44537 9.37337C7.41871 9.33337 7.39869 9.29337 7.38536 9.25337C7.36536 9.21337 7.35202 9.17338 7.34536 9.13338C7.33869 9.08671 7.33203 9.0467 7.33203 9.00004C7.33203 8.91337 7.35202 8.8267 7.38536 8.7467C7.41869 8.6667 7.46537 8.59338 7.52537 8.52671C7.71204 8.34004 8.01203 8.28003 8.25203 8.3867C8.3387 8.42003 8.40536 8.46671 8.47203 8.52671C8.59203 8.65338 8.66536 8.8267 8.66536 9.00004C8.66536 9.0467 8.65871 9.08671 8.65204 9.13338C8.64537 9.17338 8.63204 9.21337 8.61204 9.25337C8.59871 9.29337 8.57869 9.33337 8.55202 9.37337C8.52536 9.4067 8.49869 9.44003 8.47203 9.47337C8.40536 9.53337 8.3387 9.58005 8.25203 9.61338C8.17203 9.64671 8.08536 9.6667 7.9987 9.6667Z"
          />
          <path
            id="Vector_7"
            d="M5.66667 12C5.58 12 5.49333 11.98 5.41333 11.9466C5.33333 11.9133 5.26001 11.8666 5.19334 11.8066C5.13334 11.74 5.08666 11.6733 5.05332 11.5866C5.01999 11.5066 5 11.42 5 11.3333C5 11.16 5.07334 10.9866 5.19334 10.86C5.26001 10.8 5.33333 10.7533 5.41333 10.7199C5.66 10.6133 5.95333 10.6733 6.13999 10.86C6.16666 10.8933 6.19999 10.9266 6.21999 10.96C6.24666 11 6.26668 11.04 6.28001 11.08C6.30001 11.12 6.31334 11.16 6.32001 11.2066C6.32667 11.2466 6.33333 11.2933 6.33333 11.3333C6.33333 11.5066 6.25999 11.68 6.13999 11.8066C6.01333 11.9266 5.84 12 5.66667 12Z"
          />
        </g>
      </g>
    </svg>
  );
};

Calendar.displayName = 'Calendar';
